import { render, staticRenderFns } from "./AgentTransactionsReportDesignOppositionList.vue?vue&type=template&id=e44af1fc&"
import script from "./AgentTransactionsReportDesignOppositionList.vue?vue&type=script&lang=js&"
export * from "./AgentTransactionsReportDesignOppositionList.vue?vue&type=script&lang=js&"
import style0 from "./AgentTransactionsReportDesignOppositionList.vue?vue&type=style&index=0&id=e44af1fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports